export const CURRENCY_CHANGE = 'CURRENCY_CHANGE';
export const ADD = 'ADD';
export const REMOVE = 'REMOVE';
export const RESIZE = 'RESIZE';
export const REMOVE_ITEM_DATA = 'REMOVE_ITEM_DATA';
export const CURRENCY_SWITCHER = 'CURRENCY_SWITCHER';
export const TOGGLE_CART = 'TOGGLE_CART';

export const GET_PRODUCTS_LIST = 'GET_PRODUCTS_LIST';
export const GET_PRODUCT_DESCRIPTION = 'GET_PRODUCT_DESCRIPTION';
export const GET_CURRENCIES = 'GET_CURRENCIES';
export const GET_CATEGORIES = 'GET_CATEGORIES';

export const PRODUCTS_LIST_DATA_ERROR = 'PRODUCTS_LIST_DATA_ERROR';
export const PRODUCT_DESCRIPTION_DATA_ERROR = 'PRODUCT_DESCRIPTION_DATA_ERROR';
export const CURRENCIES_DATA_ERROR = 'CURRENCIES_DATA_ERROR';
export const CATEGORIES_DATA_ERROR = 'CATEGORIES_DATA_ERROR';
